import { apiConstants } from '../../apiConstant'
import { serviceCall, serviceCallAuth } from '../../serviceCall'

export const deleteNotification = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.NOTIFICATION.DELETE_NOTIFICATION,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
